export default {
  MuiDialog: {
    paper: {
      borderRadius: 10,
    },
  },
};
